/**
 * vue-cesium - https://github.com/zouyaoji/vue-cesium
 * Vue 2.x components for CesiumJS.
 *
 * @package VueCesium
 * @author zouyaoji <370681295@qq.com>
 * @version 2.4.2
 * @license MIT
 * @homepage https://zouyaoji.top/vue-cesium
 * @copyright (c) 2018-2023, zouyaoji <370681295@qq.com>
 */
/*
 * @Author: zouyaoji@https://github.com/zouyaoji
 * @Date: 2021-04-06 09:23:38
 * @LastEditTime: 2021-09-09 09:46:57
 * @LastEditors: zouyaoji
 * @Description:
 * @FilePath: \vue-cesium-v2\src\exts\imageryProvider\TiandituMapsStyle.js
 */
var TiandituMapsStyle = {
  IMG_W: 'img_w',
  IMG_C: 'img_c',
  CIA_W: 'cia_w',
  CIA_C: 'cia_c',
  VEC_W: 'vec_w',
  VEC_C: 'vec_c',
  TER_W: 'ter_w',
  TER_C: 'ter_c',
  CVA_W: 'cva_w',
  CVA_C: 'cva_c',
  CTA_W: 'cta_w',
  CTA_C: 'cta_c',
  EIA_W: 'eia_w',
  EIA_C: 'eia_c',
  EVA_W: 'eva_w',
  EVA_C: 'eva_c',
  IBO_C: 'ibo_c',
  IBO_W: 'ibo_w'
};

export default TiandituMapsStyle;
